import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

import {
  AUDIENCE_COPY,
  type AudienceDescriptor,
  type AudienceMode,
} from '@/content/audienceCopy';

type AudienceContextValue = {
  mode: AudienceMode;
  setMode: (mode: AudienceMode) => void;
  descriptors: AudienceDescriptor;
};

const AudienceContext = createContext<AudienceContextValue | undefined>(undefined);

export function AudienceProvider({ children }: { children: ReactNode }) {
  const [mode, setMode] = useState<AudienceMode>('b2b');

  const value = useMemo<AudienceContextValue>(() => {
    return {
      mode,
      setMode,
      descriptors: AUDIENCE_COPY[mode],
    };
  }, [mode]);

  return <AudienceContext.Provider value={value}>{children}</AudienceContext.Provider>;
}

export function useAudience() {
  const context = useContext(AudienceContext);

  if (!context) {
    throw new Error('useAudience must be used within AudienceProvider');
  }

  return context;
}

export type { AudienceMode, AudienceDescriptor };
